import { makeApiCall } from "../lib/api/helpers";
import {
  getApplicationApi,
  getRedirectInstantPaymentApplicationApi,
  getApplicationRedirectApi,
  patchApplicationApi
} from "../lib/api";

export const GET_APPLICATION = "application/GET_APPLICATION";
export const GET_APPLICATION_REDIRECT = "application/GET_APPLICATION_REDIRECT";
export const GET_REDIRECT_INSTANT_PAYMENT = "application/GET_REDIRECT_INSTANT_PAYMENT";
export const PATCH_APPLICATION = "application/PATCH_APPLICATION";

export const getApplication = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_APPLICATION,
    dispatch,
    getState,
    apiCall: getApplicationApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const getRedirectInstantPaymentApplication = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_REDIRECT_INSTANT_PAYMENT,
    dispatch,
    getState,
    apiCall: getRedirectInstantPaymentApplicationApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data,
  });
};

export const getApplicationRedirect = (uuid) => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_APPLICATION_REDIRECT,
    dispatch,
    getState,
    apiCall: getApplicationRedirectApi,
    apiArgs: [uuid],
    formatResponse: (response) => response.data.data,
  });
};

export const patchApplication = (payload, uuid) => async (
  dispatch,
  getState
) => {
  return makeApiCall({
    action: PATCH_APPLICATION,
    dispatch,
    getState,
    spinner: true,
    apiCall: patchApplicationApi,
    apiArgs: [payload, uuid],
    formatResponse: (response) => response.data,
  });
};

export default (
  state = {
    status: '',
  },
  action
) => {
  switch (action.type) {
    case `${GET_APPLICATION}_SUCCESS`:
      return {
        ...state,
        in_progress: false,
        ...action.payload,
      };

    case `${PATCH_APPLICATION}_SUCCESS`:
      return { ...state, status: '' };

    default:
      return state;
  }
};
